import React, { useCallback, useState } from "react";

import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "Components/Common/ChartDynamicColor";
import { useFormik } from "formik";
import { Form } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  CardBody,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import * as Yup from "yup";

export const GraficHistoricalBalance = ({ dataColors }: any) => {
  const spineareaChartColors = getChartColorsArray(dataColors);

  const series = [
    {
      name: "USDC",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "BTC",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "USD",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
  ];

  const options: any = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },

    colors: spineareaChartColors,
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00",
        "2018-09-19T01:30:00",
        "2018-09-19T02:30:00",
        "2018-09-19T03:30:00",
        "2018-09-19T04:30:00",
        "2018-09-19T05:30:00",
        "2018-09-19T06:30:00",
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      height="250"
    />
  );
};

// const WalletOverView = ({ wallet }: any) => {
//   const options: any = {
//     chart: { toolbar: { show: !1 } },
//     dataLabels: { enabled: !1 },
//     stroke: { curve: "smooth", width: 2, dashArray: [0, 0, 3] },
//     fill: { type: "solid", opacity: [0.15, 0.05, 1] },
//     xaxis: {
//       categories: [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ],
//     },
//     colors: ["#f1b44c", "#556ee6", "#50a5f1"],
//   };

//   return (
//     <Card>
//       <CardBody>
//         <h4 className="card-title mb-3">Overview</h4>
//         <div>
//           <div id="overview-chart" dir="ltr">
//             <ReactApexChart
//               series={wallet.series.length ? wallet.series : {}}
//               options={options}
//               type="line"
//               height={240}
//               className="apex-charts"
//             />
//           </div>
//         </div>
//       </CardBody>
//     </Card>
//   );
// };

const AccountsOverview: React.FC = () => {
  //meta title
  document.title = "Accounts";
  const FlatPickr: React.ComponentType<any> =
    require("react-flatpickr").default;

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: "",
      billingName: "",
      orderDate: "",
      total: "",
      paymentStatus: "",
      badgeClass: "success",
      paymentMethod: "",
    },
    validationSchema: Yup.object({
      orderId: Yup.string().required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderDate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string().required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeClass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: (values: any) => {
      const newOrder = {
        id: Math.floor(Math.random() * (30 - 20)) + 20,
        orderId: values["orderId"],
        billingName: values["billingName"],
        orderDate: values["orderDate"],
        total: values["total"],
        paymentStatus: values["paymentStatus"],
        paymentMethod: values["paymentMethod"],
        badgeClass: values["badgeClass"],
      };
      // save new order
      validation.resetForm();

      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  return (
    <React.Fragment>
      <Card>
        <div className="d-flex justify-content-end mt-3 mb-3 gap-3">
          {/* <button
              className="btn btn-secondary"
              style={{ marginRight: "30px" }}
              onClick={() => {
                setModal(true);
              }}
            >
              Add Account
            </button> */}
          {/* <button className="btn btn-danger ">Money Account</button> */}
        </div>
        <div>
          <Row>
            <Col lg={4} sm={8}>
              <div className="h-100 p-4 ">
                <div className="flex items-center gap-2 text-gray-700 text-lg font-semibold">
                  <span>
                    <i className="bx bxs-buildings"></i>
                  </span>
                  <span>Business accounts</span>
                </div>
                <p className="text-gray-500 text-sm mt-1 mt-4">
                  Total balance (3 accounts)
                </p>
                <h2 className="text-3xl font-bold mt-2">$0.00</h2>
              </div>
            </Col>
            <Col lg={8} sm={4}>
              <div>
                <CardBody>
                  <GraficHistoricalBalance dataColors='["--bs-primary", "--bs-success", "--bs-warning"]' />
                </CardBody>
              </div>
            </Col>
          </Row>
          <Row>
            {/* El cardBody le da un margin al rededor y hace que no se visualize
              bien */}
            <CardBody>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Account</th>
                      <th>Balance</th>
                      <th>Pending</th>
                      <th>Money in this month</th>
                      <th>Money out this month</th>
                    </tr>
                  </thead>
                  {}
                  <tbody>
                    <tr>{/* ACA IRA LA DATA DE LAS CUENTAS */}</tr>
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Row>
        </div>
      </Card>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Edit Order" : "Add Order"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Account Name</Label>
                  <Input
                    name="orderId"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.orderId || ""}
                    invalid={
                      validation.touched.orderId && validation.errors.orderId
                        ? true
                        : false
                    }
                  />
                  {validation.touched.orderId && validation.errors.orderId ? (
                    <FormFeedback type="invalid">
                      {validation.errors.orderId}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Billing Name</Label>
                  <Input
                    name="billingName"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.billingName || ""}
                    invalid={
                      validation.touched.billingName &&
                      validation.errors.billingName
                        ? true
                        : false
                    }
                  />
                  {validation.touched.billingName &&
                  validation.errors.billingName ? (
                    <FormFeedback type="invalid">
                      {validation.errors.billingName}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Order Date</Label>
                  <FlatPickr
                    className="form-control d-block"
                    id="orderDate"
                    name="orderDate"
                    placeholder="Select date"
                    options={{
                      mode: "single",
                      dateFormat: "d M, Y",
                    }}
                    onChange={(kycBirthDate: any) => validation.setFieldValue()}
                    value={validation.values.orderDate || ""}
                  />
                  {validation.touched.orderDate &&
                  validation.errors.orderDate ? (
                    <span className="text-danger">
                      {validation.errors.orderDate}
                    </span>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Total</Label>
                  <Input
                    name="total"
                    type="number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.total || ""}
                    invalid={
                      validation.touched.total && validation.errors.total
                        ? true
                        : false
                    }
                  />
                  {validation.touched.total && validation.errors.total ? (
                    <FormFeedback type="invalid">
                      {validation.errors.total}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Total</Label>
                  <Input
                    name="paymentStatus"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.paymentStatus || ""}
                  >
                    <option>Paid</option>
                    <option>Chargeback</option>
                    <option>Refund</option>
                  </Input>
                  {validation.touched.paymentStatus &&
                  validation.errors.paymentStatus ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validation.errors.paymentStatus}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Payment Method</Label>
                  <Input
                    name="paymentMethod"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.paymentMethod || ""}
                  >
                    <option>Mastercard</option>
                    <option>Visa</option>
                    <option>Paypal</option>
                    <option>COD</option>
                  </Input>
                  {validation.touched.paymentMethod &&
                  validation.errors.paymentMethod ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validation.errors.paymentMethod}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user">
                    {!!isEdit ? "Update" : "Add"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default AccountsOverview;
